import {
   CompoundValueSerializer,
   createEncryptionKey,
   EncryptingValueSerializer,
   ImmutableValueSerializer,
   isProdEnv,
   JsonValueSerializer,
   KeyValueStoreSerializingAdapter,
} from "@fokused-me/core";
import { List } from "immutable";
import * as localforage from "localforage";

const staticEncryptKey = createEncryptionKey("qK$2Qq4%5pw&$#uJ$fMQKW&u");
const encryptor = new EncryptingValueSerializer(staticEncryptKey);

const enableEncryption = isProdEnv() || true;

const rootSerializer = new CompoundValueSerializer(
   enableEncryption ? List.of(new ImmutableValueSerializer(), encryptor) : List.of(new ImmutableValueSerializer())
);

export const createCloudNotepadSerializer = (notepadEncryptKey: string) =>
   new CompoundValueSerializer(
      enableEncryption
         ? List.of(new JsonValueSerializer(), new EncryptingValueSerializer(Buffer.from(notepadEncryptKey, "base64")))
         : List.of(new JsonValueSerializer())
   );

export function setAppEncryptionKey(encryptKey: Buffer) {
   encryptor.setCustomKeyRule({
      itemKeyIsNot: "SESSION",
      encryptKey,
   });
}

export function createLocalStore(name: string, customKey?: Buffer) {
   let serializer = rootSerializer;
   if (customKey) {
      const customEncryptor = new EncryptingValueSerializer(customKey);
      serializer = new CompoundValueSerializer(
         enableEncryption
            ? List.of(new ImmutableValueSerializer(), customEncryptor)
            : List.of(new ImmutableValueSerializer())
      );
   }
   return new KeyValueStoreSerializingAdapter(localforage.createInstance({ name }) as any, serializer);
}

export function deleteLocalStore(name: string) {
   return localforage.dropInstance({ name });
}
